import {
    RETAILER_ATTACHMENT_LIST,
    RETAILER_ATTACHMENT_LOADING,
    RETAILER_ATTACHMENT_LOADING_DONE,
} from '../../actions/retailerAttachments/retailerAttachments';

const INITIAL_STATE = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 20,
    number: 0,
    loading: false,
};

const retailerAttachments = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RETAILER_ATTACHMENT_LOADING:
            return { ...state, loading: true };
        case RETAILER_ATTACHMENT_LIST:
            return {
                ...state,
                ...action.list,
            };
        case RETAILER_ATTACHMENT_LOADING_DONE:
            return { ...state, loading: false };
        default:
            return state;
    }
};
export default retailerAttachments;
